export const BPDATA_GET_SETTINGS_REQUESTED = 'BPDATA_GET_SETTINGS_REQUESTED';
export const BPDATA_GET_SETTINGS_SUCCESS = 'BPDATA_GET_SETTINGS_SUCCESS';
export const BPDATA_GET_SETTINGS_FAILED = 'BPDATA_GET_SETTINGS_FAILED';

export const BPDATA_SAVE_SETTINGS_REQUESTED = 'BPDATA_SAVE_SETTINGS_REQUESTED';
export const BPDATA_SAVE_SETTINGS_SUCCESS = 'BPDATA_SAVE_SETTINGS_SUCCESS';
export const BPDATA_SAVE_SETTINGS_FAILED = 'BPDATA_SAVE_SETTINGS_FAILED';

export const BPDATA_GET_MINIMUM_REQUESTED = 'BPDATA_GET_MINIMUM_REQUESTED';
export const BPDATA_GET_MINIMUM_SUCCESS = 'BPDATA_GET_MINIMUM_SUCCESS';
export const BPDATA_GET_MINIMUM_FAILED = 'BPDATA_GET_MINIMUM_FAILED';
